// src/locales/si/messageCenterShiftTypes.js
export const messageCenterShiftTypes = {
  pageTitle: 'මැසේජ් සෙන්ටර් මුර වර්ග',
  pageDescription: 'මුර වර්ග සහ ඒවායේ කොමිස් ස්ලැබ් කළමනාකරණය කරන්න',
  newShiftType: 'නව මුර වර්ගය',
  editShiftType: 'මුර වර්ගය සංස්කරණය කරන්න',
  createShiftType: 'මුර වර්ගය සාදන්න',
  saveShiftType: 'මුර වර්ගය සුරකින්න',
  name: 'නම',
  defaultTimes: 'පෙරනිමි වේලාවන්',
  defaultStartTime: 'පෙරනිමි ආරම්භක වේලාව',
  defaultEndTime: 'පෙරනිමි අවසන් වේලාව',
  commissionMethod: 'කොමිස් ක්‍රමය',
  commissionMethodHelp: 'දැනට විකුණුම් අගය අනුව පමණක් ලබා ගත හැක. විස්තර/අයිතම අනුව පසුව එකතු කෙරේ.',
  defaultTarget: 'පෙරනිමි ඉලක්කය',
  defaultTargetHelp: 'මෙම ෂිෆ්ට් වර්ගයේ නව ෂිෆ්ට් සඳහා යොදන පෙරනිමි විකුණුම් ඉලක්කය.',
  perSalesValue: 'විකුණුම් අගය අනුව',
  commissionSlabs: 'කොමිස් ස්ලැබ්',
  noSlabsConfigured: 'ස්ලැබ් සකසා නැත',
  addSlab: 'ස්ලැබයක් එකතු කරන්න',
  removeSlab: 'ඉවත් කරන්න',
  minValue: 'අවම අගය',
  maxValue: 'උපරිම අගය',
  rate: 'අනුපාතය (%)',
  openEnded: 'විවෘත අවසානය',
  slabsHelp: 'අවසාන ස්ලැබය විවෘත අවසානයක් තිබිය යුතුය (උපරිම අගයක් නොමැතිව). ස්ලැබ් අතිච්ඡාදනය නොවිය යුතුය.',
  failedToLoadShiftTypes: 'මුර වර්ග පූරණය කිරීමට අසමත් විය',
  shiftTypeCreatedSuccess: 'මුර වර්ගය සාර්ථකව සාදන ලදී',
  shiftTypeUpdatedSuccess: 'මුර වර්ගය සාර්ථකව යාවත්කාලීන කරන ලදී',
  failedToSaveShiftType: 'මුර වර්ගය සුරැකීමට අසමත් විය',
  noShiftTypesYet: 'තවම මුර වර්ග නැත',
  noShiftTypesYetDescription: 'ආරම්භ කිරීමට ඔබගේ පළමු මුර වර්ගය සාදන්න',
  edit: 'සංස්කරණය',
  activeHelp: 'Inactive shift types cannot be used for new shifts',
  placeholders: {
    name: 'e.g. Day Shift',
    selectTime: 'Select time',
    defaultTarget: 'e.g. 500000',
    firstMin: '0',
    nextMin: 'e.g. {value}',
    maxValue: 'e.g. 6000',
    rate: 'e.g. 1.5',
    fixedAmount: 'e.g. 5000',
  },
  validation: {
    nameRequired: 'නම අවශ්‍යයි',
    startTimeRequired: 'පෙරනිමි ආරම්භක වේලාව අවශ්‍යයි',
    endTimeRequired: 'පෙරනිමි අවසන් වේලාව අවශ්‍යයි',
    slabMinValueInvalid: 'අවම අගය වලංගු ඍණ නොවන සංඛ්‍යාවක් විය යුතුය',
    slabRateInvalid: 'අනුපාතය වලංගු ඍණ නොවන සංඛ්‍යාවක් විය යුතුය',
    slabMaxValueRequired: 'අවසාන ස්ලැබය හැර සෑම ස්ලැබයකටම උපරිම අගයක් අවශ්‍යයි',
    minNegative: 'Min value cannot be negative',
    maxNegative: 'Max value must be a valid non-negative number',
    wholeNumber: 'Use a whole number (no decimals)',
    maxRequired: 'Max value is required when another slab follows',
    maxGreater: 'Max value must be greater than min value',
    outOfOrder: 'Slabs must be in ascending order — this slab must start at {value}',
    gap: 'Slabs cannot have gaps — this slab must start at {value}',
    lastOpenEnded: 'The last (highest) slab must be open-ended — clear its max value',
    rateNegative: 'Value cannot be negative',
    rateRequired: 'Enter a valid non-negative value',
    rateMax: 'Rate cannot exceed 100%',
    fixErrors: 'සුරැකීමට පෙර දක්වා ඇති දෝෂ නිවැරදි කරන්න',
  },
};
